@if (emailContent) {
  <!--  -->
  <!-- Desktop with preview column -->
  @if (!emailBuilderIsMobile) {
    <div class="email-builder-desktop">
      <!-- Preview -->
      <email-editor-preview [html]="renderedTemplate" [loadingIndicator]="loadingIndicator()">
        <ng-content select="[preview_header]" ngProjectAs="[preview_header]" preview_header />
      </email-editor-preview>
      <!-- Controls & Settings -->
      <glxy-resize class="email-controls" [width]="440" minWidth="360px" maxWidth="640px" appearance="standard">
        <div class="block-list-and-settings" cdkScrollable>
          <ng-container *ngTemplateOutlet="emailSetup" />
          <ng-container *ngTemplateOutlet="emailBlocksList" />
          <ng-container *ngTemplateOutlet="emailAdvancedSettings" />
        </div>
      </glxy-resize>
    </div>
  } @else {
    <mat-tab-group animationDuration="0ms">
      <mat-tab label="{{ 'EMAIL_BUILDER.MAT_LABELS.EDIT_EMAIL' | translate }}">
        <ng-template matTabContent>
          <ng-container *ngTemplateOutlet="emailSetup" />
          <ng-container *ngTemplateOutlet="emailBlocksList" />
        </ng-template>
      </mat-tab>
      <mat-tab label="{{ 'EMAIL_BUILDER.MAT_LABELS.PREVIEW' | translate }}">
        <email-editor-preview [html]="renderedTemplate" [previewIsMobile]="true">
          <ng-content select="[preview_header]" ngProjectAs="[preview_header]" preview_header />
        </email-editor-preview>
      </mat-tab>
      <mat-tab label="{{ 'EMAIL_BUILDER.MAT_LABELS.ADVANCED' | translate }}">
        <ng-container *ngTemplateOutlet="emailAdvancedSettings" />
      </mat-tab>
    </mat-tab-group>
  }
} @else {
  <glxy-loading-spinner [fullWidth]="true" [fullHeight]="true" />
}

<!-- ==================================== -->
<!--              Templates               -->
<!-- ==================================== -->

<!-- Email Controls Tab: Subject -->
<ng-template #emailSetup>
  <form #emailSetupForm="ngForm">
    <div class="email-settings-container">
      <glxy-form-field>
        <glxy-label>{{ 'EMAIL_BUILDER.SUBJECT_CONTROLS_TAB.TEMPLATE_NAME' | translate }}</glxy-label>
        <input matInput required [(ngModel)]="emailContent.name" name="Template Name" autocomplete="off" />
      </glxy-form-field>
    </div>

    <mat-divider />

    <div class="email-settings-container">
      <email-input-with-dynamic-contents
        [title]="'EMAIL_BUILDER.SUBJECT_CONTROLS_TAB.SUBJECT_LINE' | translate"
        [elementId]="'email-builder-subject-input'"
        [content]="emailContent.subjectLine"
        (contentChange)="subjectLineUpdated($event)"
        [required]="true"
      >
      </email-input-with-dynamic-contents>
      <email-input-with-dynamic-contents
        [title]="'EMAIL_BUILDER.SUBJECT_CONTROLS_TAB.INBOX_PREVIEW' | translate"
        [titleHint]="'EMAIL_BUILDER.SUBJECT_CONTROLS_TAB.INBOX_PREVIEW_HINT' | translate"
        [elementId]="'email-builder-preview-text-input'"
        [content]="emailContent.previewText"
        (contentChange)="previewTextUpdated($event)"
        [required]="false"
      >
      </email-input-with-dynamic-contents>
    </div>
  </form>
</ng-template>

<!-- Email Controls Tab: Content List -->
<ng-template #emailBlocksList>
  <email-blocks-list [blocks]="emailContent.emailContentBlocks" [optionalBlockTypes]="optionalBlockTypes" />
</ng-template>

<!-- Email Controls Tab: Page Setup -->
<ng-template #emailAdvancedSettings>
  <email-advanced-settings [emailSetup]="emailContent.emailSetup" [sectionsEnabled]="advancedSections" />
</ng-template>
